import qs from "qs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Modal } from "src/api/public-types";
import { BaseModal, ContentsTitle } from "src/components";
import useNavigate from "src/hooks/usePartnerNavigate";
import BasicInfoForm from "./components/BasicInfoForm";
import { vocTabs } from "../voc-constants";
import VocAlramSetting from "../detail/components/VocAlramSetting";
import { CsItemModel, VocQueryParams } from "src/api/voc/voc-types";
import { useApiOperation } from "src/api/hooks";
import { getVocListAsync } from "src/api/voc/voc-api";

const VocForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = useMemo(
    () =>
      qs.parse(location.search, {
        ignoreQueryPrefix: true,
        allowDots: true,
      }),
    [location],
  );
  const [modal, setModal] = useState<Modal>({
    isOpen: false,
  });

  const [vocDetail, setVocDetail] = useState<CsItemModel>();
  // Voc 상세
  const { executeAsync: getList } = useApiOperation(getVocListAsync);

  useEffect(() => {
    const fetchVocList = async (passParams: VocQueryParams) => {
      const { data } = await getList(passParams);
      setVocDetail(data.data.content[0]);
    };

    if (queryParams?.id) {
      const params = {
        searchType: "id",
        keywordList: String(queryParams?.id),
      };
      fetchVocList(params);
    }
  }, [getList]);

  // 현재 활성화 되어야하는 tab
  const activeTab = useMemo(() => {
    if (queryParams?.tab) {
      return vocTabs.find((tab) => tab.value === queryParams?.tab);
    }
    return vocTabs[0];
  }, [queryParams]);

  // 탭 클릭시 callback 함수
  const clickTab = useCallback(
    (tab: { value: string; label: string }) => {
      // 기본정보 가 작성되지 않은 상태에서, 다른 탭으로 이동하려고 할 경우.
      if (tab.value !== "basicInfo" && !queryParams.id) {
        setModal({
          isOpen: true,
          title: "기본정보가 저장되지 않았습니다.",
        });
        return;
      }
      const newQueryParams = { ...queryParams };
      if (newQueryParams?.tab) {
        delete newQueryParams.tab;
      }

      newQueryParams.tab = tab.value;

      // query parameter 에 tab 추가
      const newQueryParamStr = qs.stringify(newQueryParams, { allowDots: true });
      navigate(location.pathname + "?" + decodeURIComponent(newQueryParamStr));
    },
    [navigate, location, queryParams],
  );

  return (
    <div>
      <ContentsTitle
        title="Voc 항목"
        tabs={vocTabs}
        activeTab={activeTab}
        clickTab={clickTab}
        detailInfo={(queryParams.id && [{ title: "신청id", value: String(queryParams.id) || "" }]) || []}
      />
      {/* 탭 */}
      {/* 기본정보 */}
      {activeTab?.value === "basicInfo" && ( //
        <BasicInfoForm vocDetail={vocDetail} />
      )}
      {activeTab?.value === "alarmSetting" && <VocAlramSetting vocDetail={vocDetail} />}

      <>
        {modal.isOpen && <BaseModal isOpen={true} title={modal.title} btnRightTitle={"확인"} onClick={() => setModal({ ...modal, isOpen: false })} />}
      </>
    </div>
  );
};

export default VocForm;
